import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instructions-modal',
  templateUrl: './instructions-modal.component.html',
  styleUrls: ['./instructions-modal.component.scss']
})
export class InstructionsModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
